<img class="right-oval" src="assets/img/ovals/grey-oval-right.png" />

<ion-content>
  <div class="page-container">
    <div class="header-section">
      <div class="events-title">Revitalize your workplace</div>
      <div class="events-description">
        Experience the future of wellness at work with Shortcut, from soothing
        massages to calming mindfulness sessions.
      </div>
      <div class="code-container">
        <ion-item lines="none" class="code-item">
          <ion-input
            [(ngModel)]="code"
            placeholder="Enter event code"
            (keyup.enter)="joinEvent()"
          ></ion-input>
        </ion-item>
        <ion-button color="marine" class="search-button" (click)="joinEvent()"
          >Submit</ion-button
        >
      </div>
    </div>

    <div class="recents-section">
      <div class="loading-container" *ngIf="!recentlyViewedEvents">
        <ion-spinner></ion-spinner>
      </div>
      <div
        class="recently-viewed-header"
        *ngIf="recentlyViewedEvents && recentlyViewedEvents.length"
      >
        Recently viewed
      </div>
      <div
        *ngFor="let e of recentlyViewedEvents; let i = index"
        class="recent-event"
        (click)="goToRecentlyViewedEvent(e)"
      >
        <img src="assets/img/recent-event-{{i}}.jpg" />
        <div class="recent-name">{{ e.name }}</div>
      </div>
    </div>

    <div class="slack-section">
      <div class="slack-wrapper">
        <div class="slack-button-disabled">
          <img
            alt="Add to Slack"
            height="40"
            width="139"
            src="https://platform.slack-edge.com/img/add_to_slack.png"
            srcset="
              https://platform.slack-edge.com/img/add_to_slack.png    1x,
              https://platform.slack-edge.com/img/add_to_slack@2x.png 2x
            "
          />
        </div>

        <div class="slack-text">
          Submit your event code, and add our Slack integration to get reminders
          for Shortcut events.
        </div>
      </div>
    </div>

    <div class="request-section">
      <div class="img-left">
        <img src="assets/img/tradestation.jpg" />
      </div>
      <div class="text-right">
        <div class="events-title">Want to request an event?</div>
        <div class="events-description">
          Shortcut Pros organize everything – staffing, scheduling and cleanup.
          Get the best in onsite services, including Haircuts, Massages,
          Blowouts and Mindfulness sessions. Fill out a request and we'll
          contact you within 24 hours.
        </div>
        <ion-button color="marine" class="request-button" (click)="learnMore()"
          >Learn more</ion-button
        >
      </div>
    </div>

    <div class="partners-section">
      <div class="sec_event_tab">
        <div class="tabs tab_slider">
          <div class="item">
            <div
              class="tab-link"
              [ngClass]="selectedTab == 0 ? 'current' : ''"
              data-tab="tab-1"
              (click)="selectTab(0)"
            >
              Office events
            </div>
          </div>
          <div class="item">
            <div
              class="tab-link"
              [ngClass]="selectedTab == 1 ? 'current' : ''"
              data-tab="tab-2"
              (click)="selectTab(1)"
            >
              Weddings
            </div>
          </div>
          <div class="item">
            <div
              class="tab-link"
              [ngClass]="selectedTab == 2 ? 'current' : ''"
              data-tab="tab-3"
              (click)="selectTab(2)"
            >
              Special activations
            </div>
          </div>
        </div>
        <div class="main">
          <div
            id="tab-1"
            class="tab-content"
            [ngClass]="selectedTab == 0 ? 'current' : ''"
          >
            <div class="main_block">
              <div class="img_part">
                <ul>
                  <li
                    class="background-image"
                    style="
                      background-image: url('assets/img/events-office-1.jpg');
                    "
                  ></li>
                  <li
                    class="background-image"
                    style="
                      background-image: url('assets/img/events-office-2.jpg');
                    "
                  ></li>
                </ul>
              </div>
              <div class="content_part">
                <div class="testi">
                  <p>
                    "Shortcut has made employee amenities easy for us. We’re
                    able to lock in an annual contract with the same recurring
                    day each month, so our staff can rely on the same expert
                    barber services month over month."
                  </p>
                </div>
                <div class="pro_tag">
                  <div class="pro_img">
                    <img src="assets/img/events-vayner.jpg" alt="" title="" />
                  </div>
                  <p>Dannie, Office Manager, VaynerMedia</p>
                </div>
                <div class="box_btn">
                  <a class="btn_blue" (click)="requestEvent()"
                    >Request an office event</a
                  >
                </div>
              </div>
            </div>
          </div>
          <div
            id="tab-2"
            class="tab-content"
            [ngClass]="selectedTab == 1 ? 'current' : ''"
          >
            <div class="main_block">
              <div class="img_part">
                <ul>
                  <li
                    class="background-image"
                    style="
                      background-image: url('assets/img/events-wedding-1.jpg');
                    "
                  ></li>
                  <li
                    class="background-image"
                    style="
                      background-image: url('assets/img/events-wedding-2.jpg');
                    "
                  ></li>
                </ul>
              </div>
              <div class="content_part">
                <div class="testi">
                  <p>
                    "The Shortcut team was incredible and especially the hot
                    towels shaves, which were awesome. They came equipped with
                    everything. The girls weren't the only ones getting pampered
                    that day."
                  </p>
                </div>
                <div class="pro_tag">
                  <div class="pro_img">
                    <img src="assets/img/events-will.jpg" alt="" title="" />
                  </div>
                  <p>Will, New York City</p>
                </div>
                <div class="box_btn">
                  <a class="btn_blue" (click)="requestEvent()"
                    >Request wedding services</a
                  >
                </div>
              </div>
            </div>
          </div>
          <div
            id="tab-3"
            class="tab-content"
            [ngClass]="selectedTab == 2 ? 'current' : ''"
          >
            <div class="main_block">
              <div class="img_part">
                <ul>
                  <li
                    class="background-image"
                    style="
                      background-image: url('assets/img/events-special-1.jpg');
                    "
                  ></li>
                  <li
                    class="background-image"
                    style="
                      background-image: url('assets/img/events-special-2.jpg');
                    "
                  ></li>
                </ul>
              </div>
              <div class="content_part">
                <div class="testi">
                  <p>
                    "The Delta team was so appreciative of you all coming to
                    pamper them. Your app process, I truly feel took all of the
                    worry out of trying to set up an event of this size... We
                    look forward to doing this again!"
                  </p>
                </div>
                <div class="pro_tag">
                  <div class="pro_img">
                    <img src="assets/img/events-delta.jpg" alt="" title="" />
                  </div>
                  <p>Daniella, Office Manager, Delta Airlines</p>
                </div>
                <div class="box_btn">
                  <a class="btn_blue" (click)="requestEvent()"
                    >Request an activation</a
                  >
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</ion-content>
